import { render } from "./AddPayment.vue?vue&type=template&id=5845275f&scoped=true"
import script from "./AddPayment.vue?vue&type=script&lang=js"
export * from "./AddPayment.vue?vue&type=script&lang=js"

import "./AddPayment.vue?vue&type=style&index=0&id=5845275f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5845275f"]])

export default __exports__